module.exports = __webpack_public_path__ + "static/linguamillMobile-e25e624d5ec8d0cb09eac336d02c6421.jpg";